"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TokenValidator = _interopRequireDefault(require("../../../core/TokenValidator"));

var _FetchHelper = _interopRequireDefault(require("../../../core/FetchHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BookingService =
/*#__PURE__*/
function () {
  function BookingService(url, kundennummer, obtainTokenMethod, removeTokenMethod) {
    _classCallCheck(this, BookingService);

    this.url = url;
    this.kundennummer = kundennummer;
    this.obtainTokenMethod = obtainTokenMethod;
    this.removeTokenMethod = removeTokenMethod;
  }

  _createClass(BookingService, [{
    key: "getBooking",
    value: function getBooking(meetingId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].get(this.url + "/book/" + meetingId, options);
    }
  }, {
    key: "getBossBooking",
    value: function getBossBooking(hash) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].get(this.url + "/book/boss/" + hash + "?customer=" + this.kundennummer, options);
    }
  }, {
    key: "processBossBooking",
    value: function processBossBooking(booking) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].post(this.url + "/book/boss/process?customer=" + this.kundennummer, options);
    }
  }, {
    key: "update",
    value: function update(booking) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].put(this.url + "/book/", options);
    }
  }, {
    key: "bookCourse",
    value: function bookCourse(booking, courseId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].post(this.url + "/book/course/" + courseId, options);
    }
  }, {
    key: "deleteCourseBooking",
    value: function deleteCourseBooking(courseId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"]["delete"](this.url + "/book/course/" + courseId, options);
    }
  }, {
    key: "bookWebinar",
    value: function bookWebinar(booking, webinarId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].post(this.url + "/book/webinar/" + webinarId, options);
    }
  }, {
    key: "bookProjectMeetingBundle",
    value: function bookProjectMeetingBundle(booking) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].post(this.url + "/book/meeting-bundle/project/", options);
    }
  }, {
    key: "updateProjectMeetingBundle",
    value: function updateProjectMeetingBundle(projectId, booking) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].put(this.url + "/book/meeting-bundle/project/" + projectId, options);
    }
  }, {
    key: "cancelProjectMeetingBundle",
    value: function cancelProjectMeetingBundle(projectId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "authorization": token
        }
      };
      return _FetchHelper["default"]["delete"](this.url + "/book/meeting-bundle/project/" + projectId, options);
    }
  }, {
    key: "deleteWebinarBooking",
    value: function deleteWebinarBooking(webinarId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"]["delete"](this.url + "/book/webinar/" + webinarId, options);
    }
  }, {
    key: "bookMeeting",
    value: function bookMeeting(booking, meetingId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].post(this.url + "/book/meeting/" + meetingId, options);
    }
  }, {
    key: "bookRequest",
    value: function bookRequest(booking, meetingId, userId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].post(this.url + "/book/request/" + meetingId + "/" + userId, options);
    }
  }, {
    key: "deleteMeetingBooking",
    value: function deleteMeetingBooking(meetingId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"]["delete"](this.url + "/book/meeting/" + meetingId, options);
    }
  }, {
    key: "bookProject",
    value: function bookProject(booking, projectId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].post(this.url + "/book/project/" + projectId, options);
    }
  }, {
    key: "deleteProjectBooking",
    value: function deleteProjectBooking(projectId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"]["delete"](this.url + "/book/project/" + projectId, options);
    }
  }, {
    key: "directBookCourse",
    value: function directBookCourse(courseId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].post(this.url + "/book/course/" + courseId + "/direct", options);
    }
  }, {
    key: "directBookWebinar",
    value: function directBookWebinar(webinarId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].post(this.url + "/book/webinar/" + webinarId + "/direct", options);
    }
  }, {
    key: "directBookMeeting",
    value: function directBookMeeting(meetingId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].post(this.url + "/book/meeting/" + meetingId + "/direct", options);
    }
  }, {
    key: "directBookProject",
    value: function directBookProject(projectId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].post(this.url + "/book/course/" + projectId + "/direct", options);
    }
  }, {
    key: "addToWaitlist",
    value: function addToWaitlist(meetingId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].post(this.url + "/book/waitlist/" + meetingId, options);
    }
  }, {
    key: "addToWaitlist",
    value: function addToWaitlist(booking, meetingId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        },
        body: booking
      };
      return _FetchHelper["default"].post(this.url + "/book/waitlist/" + meetingId, options);
    }
  }, {
    key: "addToReserveList",
    value: function addToReserveList(meetingId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token
        }
      };
      return _FetchHelper["default"].post(this.url + "/book/reserve/" + meetingId, options);
    }
  }]);

  return BookingService;
}();

exports["default"] = BookingService;
;